/*
* BinaryDetailsReducer.js
* Copyright (c) Harman International Industries, Incorporated, 2024 - 2025
* All rights reserved.
*/
import {
    FETCH_BINARY_KEY_DETAILS_REQUEST,FETCH_BINARY_KEY_DETAILS_SUCCESS,FETCH_BINARY_KEY_DETAILS_FAILURE,FETCH_BINARY_KEY_DELETE_REQUEST,FETCH_BINARY_KEY_DELETE_SUCCESS,FETCH_BINARY_KEY_DELETE_FAILURE
   } from "./BinaryDetailsTypes";

   const initialState = {
    loading: false,
    binaryKeyData: {},
    error: "",
  };

    const binaryKeyDetailsReducer = (state = initialState, action) => {
      switch (action.type) {
        case FETCH_BINARY_KEY_DETAILS_REQUEST:
            return {
              ...state,
              loading: true,
            };
          
        case FETCH_BINARY_KEY_DETAILS_SUCCESS:
          return {
            loading: false,
            binaryKeyData: action.payload,
            error: "",
          };
        case FETCH_BINARY_KEY_DETAILS_FAILURE:
          return {
            loading: false,
            binaryKeyData: {},
            error: action.payload,
          };
  
        case FETCH_BINARY_KEY_DELETE_REQUEST:
          return{
            loading:true,
            binaryKeyData:{},
            error:false
          };
        
          case FETCH_BINARY_KEY_DELETE_SUCCESS:
            return{
              loading:false,
              binaryKeyData:{},
              error:""
            } 
            case FETCH_BINARY_KEY_DELETE_FAILURE:
            return{
              loading:false,
              binaryKeyData:{},
              error:action.payload
            } 
        default:
          return state;
      }
    };
    
    export default binaryKeyDetailsReducer;